export default {
  title: {
    id: 'dashboard_menu_bm_pro_title',
    defaultMessage: 'Shopping for your business?',
  },
  subtitle: {
    id: 'dashboard_menu_bm_pro_subtitle',
    defaultMessage:
      'Check out our dedicated services for enterprises including B2B invoices, VAT exemption and much more – all on Back Market Pro.',
  },
  cta: {
    id: 'dashboard_menu_bm_pro_cta',
    defaultMessage: 'Go to Back Market Pro',
  },
  imageAlt: {
    id: 'dashboard_menu_bm_pro_image_alt',
    defaultMessage: 'Illustration of a person shopping on Back Market Pro',
  },
}
